import { Result } from 'antd';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as NotFoundSvg } from 'assets/svgs/404.svg';
import { Page as PageAtom } from 'components/molecules/page';
import { useTranslation } from 'hooks/use-translation';

const Page = styled(PageAtom)`
  justify-content: center;
`;

export const NotFound: FC = () => (
  <Page $gray>
    <Helmet>
      <title>{useTranslation('error.404.title')}</title>
    </Helmet>
    <Result
      title={useTranslation('error.404.title')}
      icon={<NotFoundSvg />}
      subTitle={useTranslation('error.404.message')}
      extra={
        <Link to="/" type="primary">
          {useTranslation('error.404.action')}
        </Link>
      }
    />
  </Page>
);
